var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"table-empty box card-cambio text-center"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"icon"},[_c('i',{class:_vm.icon})]),_c('span',{staticClass:"title-table-empty"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.subtitle)?_c('span',{staticClass:"subtitle-table-empty"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }